import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, AlertCircle, X } from 'lucide-react';

interface ToastProps {
  message: string | null;
  type?: 'success' | 'error' | 'info';
  onClose?: () => void;
}

export const Toast: React.FC<ToastProps> = ({ message, type = 'success', onClose }) => {
  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircle size={20} className="text-green-400" />;
      case 'error':
        return <AlertCircle size={20} className="text-red-400" />;
      default:
        return <CheckCircle size={20} className="text-blue-400" />;
    }
  };

  const getBgColor = () => {
    switch (type) {
      case 'success':
        return 'bg-green-900 bg-opacity-80';
      case 'error':
        return 'bg-red-900 bg-opacity-80';
      default:
        return 'bg-blue-900 bg-opacity-80';
    }
  };

  return (
    <AnimatePresence>
      {message && (
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 50, scale: 0.9 }}
          transition={{ duration: 0.3, type: 'spring', stiffness: 300 }}
          className="fixed bottom-20 left-1/2 transform -translate-x-1/2 z-50"
        >
          <div className={`${getBgColor()} backdrop-blur-lg border border-white border-opacity-20 rounded-lg px-4 py-3 shadow-xl flex items-center space-x-3 text-white min-w-64`}>
            {getIcon()}
            <span className="flex-1 text-sm font-medium">{message}</span>
            {onClose && (
              <button
                onClick={onClose}
                className="text-white opacity-60 hover:opacity-100 transition-opacity"
              >
                <X size={16} />
              </button>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};